/** Normalise un tableau de nombres à exactement `n` éléments (pad avec 0 ou tronque). */
export function normalizeArrayNums(raw: unknown, n: number): number[] {
  const out: number[] = Array(n).fill(0);
  if (!Array.isArray(raw)) return out;
  const len = Math.min(raw.length, n);
  for (let i = 0; i < len; i++) {
    const v = raw[i];
    const num = v == null ? 0 : Number(v);
    out[i] = Number.isFinite(num) ? num : 0;
  }
  return out;
}

/** Normalise un tableau de valeurs nullable à exactement `n` éléments (pad avec null). */
export function normalizeArrayNulls(raw: unknown, n: number): (number | null)[] {
  const out: (number | null)[] = Array(n).fill(null);
  if (!Array.isArray(raw)) return out;
  const len = Math.min(raw.length, n);
  for (let i = 0; i < len; i++) {
    const v = raw[i];
    if (v == null) { out[i] = null; continue; }
    const num = Number(v);
    out[i] = Number.isFinite(num) ? num : null;
  }
  return out;
}

/** Rétro-compat : normalise à 36 éléments. */
export function normalizeLength36Nums(raw: unknown): number[] {
  return normalizeArrayNums(raw, 36);
}
